module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"// memotipTitle":"Hvordan huske","memotipTitle":"Husketips"},"en":{"// memotipTitle":"How to remember","memotipTitle":"Memo tips"}}')
  delete Component.options._Ctor
}
